import { useEffect } from 'react';
import { visitorTracking } from '../utils/visitorTracking';
export const useVisitorTracking = (siteId, apiUri, isEnable) => {
  useEffect(() => {
    try {
      if (isEnable) {
        visitorTracking(siteId, apiUri);
      }
    } catch (e) {
      console.log(`${e.name} : ${e.message}`);
    }
  }, [siteId, apiUri]);
};